import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {LayoutModule} from '../../components/layout/layout.module';
import {RoutingGroupsPanelComponent} from './routing-groups-panel/routing-groups-panel.component';
import {GroupsComponent} from './groups.component';
import {VirtualScrollerModule} from 'ngx-virtual-scroller';
import {MaterialModule} from '../../material.module';
import {ActionBarModule} from '../../components/action-bar/action-bar.module';
import {RoutingGroupsDialogComponent} from './routing-groups-dialog/routing-groups-dialog.component';
import {FormsModule} from '@angular/forms';
import {InfraModule} from 'ac-infra';
import {RuleActionBoxComponent} from './routing-rules-panel/rule-action-box/rule-action-box.component';
import {RuleAdvanceConditionComponent} from './routing-rules-panel/rule-condition-box/rule-advance-condition/rule-advance-condition.component';
import {RuleDestinationConditionComponent} from './routing-rules-panel/rule-condition-box/rule-destination-condition/rule-destination-condition.component';
import {RuleSourceConditionComponent} from './routing-rules-panel/rule-condition-box/rule-source-condition/rule-source-condition.component';
import {RoutingRulesPanelComponent} from './routing-rules-panel/routing-rules-panel.component';
import {SearchModule} from '../../components/search/search.module';
import {RoutingGroupsSearchComponent} from './routing-groups-search/routing-groups-search.component';
import {DialogModule} from '../../components/dialog/dialog.module';
import {ArmFormTitleModule} from '../../components/arm-form/arm-form-title/arm-form-title.module';

@NgModule({
  declarations: [
    RoutingGroupsPanelComponent,
    GroupsComponent,
    RoutingGroupsDialogComponent,
    RuleActionBoxComponent,
    RoutingRulesPanelComponent,
    RuleAdvanceConditionComponent,
    RuleDestinationConditionComponent,
    RuleSourceConditionComponent,
    RoutingGroupsSearchComponent
  ],
  imports: [
    CommonModule,
    LayoutModule,
    VirtualScrollerModule,
    MaterialModule,
    ActionBarModule,
    FormsModule,
    InfraModule,
    SearchModule,
    DialogModule,
    ArmFormTitleModule
  ]
})
export class GroupsModule { }
